import { render, staticRenderFns } from "./main-component.vue?vue&type=template&id=20c360be"
import script from "./main-component.vue?vue&type=script&lang=js"
export * from "./main-component.vue?vue&type=script&lang=js"
import style0 from "./main-component.vue?vue&type=style&index=0&id=20c360be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports